import React from "react";
import {Image} from "react-bootstrap";
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroller";

import OpportunityShareContainer from "./components/shares";

import PlaceholderEmptyMessage from "src/legacy/components/PlaceholderEmptyMessage";

import ConversationNotFound from 'src/legacy/images/ConversationNotFound.svg';
import styles from "./styles.module.scss";

const PaperfliteIcon = '/images/Paperflite.png';

class OpportunitySharesView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      currentPage: this.props.currentPage,
      showShareView: false,
      showDeleteConfirmation: false,
      fetchShares:false
    };

    this.loadMoreShares = this.loadMoreShares.bind(this);
  }

  loadMoreShares() {
    var currentPage = this.props.currentPage;

    if (!this.props.shares) {
      return;
    }

    if (this.props.loadingShares) {
      return;
    }

    this.props.fetchData(this.props.id, currentPage + 1)
  }

 componentDidMount() {

    this.props.fetchUserProfile();

    if (this.props.id) {
      this.props.fetchData(this.props.id, 0);
    }
  }

  componentWillReceiveProps(nextProps) {

    if (!_.isEqual(this.props.location.query, nextProps.location.query)) {
      this.props.fetchData(this.props.id, this.props.currentPage);
    }
  }

  _handleFetchSection(share, section) {
    return this.props.fetchShareSection(share, section);
  }

  render() {
    if (!this.props.id && !this.props.loadingShares) {
      return this._renderEmptyMessage();
    }

   return (
      <div className={styles.conversationContainer}>

        <div className={styles.shareContainer}>{this._renderShares()}</div>

        {this.props.loadingShares && (
          <div className={styles.loading}>Loading Shares... </div>
        )}

        {this.props.backdrop && <div className={styles.overlay}></div>}
      </div>
      );
  }

  _renderShares() {    
    if (!this.props.loadingShares && this.props.shares.length == 0) {
      return this._renderEmptyMessage();
    }

    var shares = this.props.shares.map((share) => {
      return (
        share && (
          <OpportunityShareContainer
            key={share.id}
            id={share.id}
            page={this.state.currentPage}
            fetchAssetAnalytics={this.props.fetchAssetAnalytics.bind(this)}
            fetchShareSection={this._handleFetchSection.bind(this)}
          />
        )
      );
    });

    return (
      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={this.props.currentPage < this.props.totalPages}
        loadMore={() => {this.loadMoreShares()}}
        useWindow={true}
        threshold={250}
      >
        {shares}
      </InfiniteScroll>
    );
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title="My grandma lost her earrings!"
        message="The conversation you're looking for doesn't exist."
        image={ConversationNotFound}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }
}

export default OpportunitySharesView;